import React, {Component} from "react";
import Footer from "./Footer";
import { Link } from 'react-router-dom';
import axios from "axios";
import store from '../store';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const categoryApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/adminuser/categoriesAPI/`
})
const GigsApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/seller/GigsAPI/`
})

class AddProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title:'',
            category:null,
            image:null,
            price:null,
            details:'',
            categories : [],
        }
        this.getCategories();
        ClassicEditor.defaultConfig = {
            toolbar: {items: ['heading','|','bold','italic','|','bulletedList','numberedList','|','insertTable','|','undo','redo']},
            table: {
              contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
            },
            language: 'en',
          };
         
    }
    handleTitle = (e) => {
        this.setState({title:e.target.value})
    }
    handleCategory = (e) => {
        this.setState({category:e.target.value})
    }
    handleImage = (e) => {
        console.log('hi');
        this.setState({image:e.target.files[0]})
    }
    handleDetails = (event, editor) => {
        this.setState({details:editor.getData()})
    }
    handlePrice = (e) => {
        this.setState({price:e.target.value})
    }

    getCategories = async () => {
        let data = await categoryApi.get('/').then(({data})=>data);
        this.setState({categories:data})
    }
    addProduct =async () => {
        let data = new FormData();
        data.append('title', this.state.title);
        data.append('category', this.state.category);
        data.append('price', this.state.price);
        data.append('details', this.state.details);
        data.append('seller', store.getState().auth.user.id);
        data.append('images', this.state.image,this.state.image.name);
        try{
        let res = await GigsApi.post('/create/',data);
        res?.status === 201 ? alert("Item Added Successfully!") : alert("can not add product now please try again later!");
        this.setState ({ title:'', category:null, image:null, price:null, details:''});
        }
        catch{
            alert('can not add product now please try again later!')
        }
    }
    
    render() {
    return(
    <>
        <br/><br/>
        <div className="container mt-5">
	    <div className="d-flex justify-content-center h-100">
        <div className="card" style={{height: '550px',marginTop: 'auto',marginBottom: 'auto',width: '600px'}}>
		    <div className="card-header">
			    <h3>Add Product</h3>
			</div>
			<div className="card-body">
				<div className="input-group form-group">
                <span className="input-group-text" style={{backgroundColor:'#FFC312',color: 'black',width:'120px'}}><b>Title</b></span>
                    <input className='form-control' type='text' placeholder='Title *' name='title' onChange={this.handleTitle}  value={this.state.title} />
				</div>
                
                <div className="input-group form-group">
                <span className="input-group-text" style={{backgroundColor:'#FFC312',color: 'black',width:'120px'}}><b>Category</b></span>
                <select className="form-select form-control" aria-label="Default select example" onChange={this.handleCategory}>
                    <option value="" disabled selected>Select Category</option>
                    {this.state.categories.map(a =>
                        <option key={a.id} value={a.id}>
                            {a.name}            
                        </option>
                    )}
                </select>
				</div>

				<div className="input-group form-group">
					<span className="input-group-text" style={{backgroundColor:'#FFC312',color: 'black',width:'120px'}}><b>Add Image</b></span>
					<input type="file" className="form-control" name="images" onChange={this.handleImage} />
				</div>
                <div className="input-group form-group">
					<span className="input-group-text" style={{backgroundColor:'#FFC312',color: 'black',width:'120px'}}><b>Price</b></span>
					<input className='form-control' type='text' placeholder='Price*' name='price' onChange={this.handlePrice} value={this.state.price}/>
				</div>
                <div className="input-group form-group ms-5">
                <span className="input-group-text" style={{backgroundColor:'#FFC312',color: 'black',width:'120px'}}><b>Details</b></span>
                <CKEditor editor={ ClassicEditor} onChange={this.handleDetails} data={this.state.details}  />
				</div>
				<div className="form-group">
                    <button className='btn btn-primary float-right' onClick={this.addProduct}  style={{color: 'black',backgroundColor: '#FFC312',width: '150px'}}>Add Product</button>
				</div>
			</div>
			<div className="card-footer">
				<div className="d-flex justify-content-center links">
					Want to Update exsisting product?<Link to='/SellerDashboard'>Update</Link>
				</div>
			</div>
		</div>
        </div>
		</div>
        <Footer />
    </>
    )
    }
} 
export default AddProduct;